<template>
  <div id="login" class="login background d-flex align-center justify-center">
    <div>
      <div class="text-center py-4"><v-img :src="require('../assets/logo.png')"></v-img></div>
  
      <div class="row p-10">
           <v-text-field 
           class="userinput"
            label="Usuario"
            prepend-inner-icon="person"
            v-model="credenciales.login" name="username"   @keyup.enter="login()"
          ></v-text-field>
      
      </div>
      <div class="row p-10">
          <v-text-field
            ref="password" 
            class="password"
            label="Contraseña"
            prepend-inner-icon="lock"
           type="password" name="password" v-model="credenciales.password" @keyup.enter="login()"
          ></v-text-field>
      </div>
        <div class="row px-0">
          <v-btn class="w-100 primary ma-0" type="button" :disabled='isDisabled' v-on:click="login()" >Enviar</v-btn>
      </div>
    <v-card v-if="usuariosLogin != null && usuariosLogin.length > 0" class="mt-3">
      <v-list>
        <template v-for="(item, index) in usuariosLogin">
          <v-subheader v-if="index === 0" :key="index + 'h'">
            Últimos empleados conectados
          </v-subheader>

          <v-divider
            v-if="index % 2"
            :key="index"
            :inset="true"
            class="my-0"
          ></v-divider>

          <v-list-tile
            :key="index + 't'"
            avatar
            @click="completarLogin(item.nombre)"
            class="py-1"
          >
            <v-list-tile-avatar class="primary-login" size="30px">
              <v-icon>account_circle</v-icon>
            </v-list-tile-avatar>

            <v-list-tile-content>
              <v-list-tile-title v-html="item.nombre"></v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-card>
   </div>
  </div>
</template>
<script>
export default {
  props: ['instalacion'],
  data() {
    return {
      valid: false,
      credenciales: {
        login: "",
        password: ""
      },
      usuariosLogin: [],
    }
  },
  beforeCreate() {
    if (this.$store.getters.isLoggedIn) {
       this.$router.push('/tienda')
    }
  },
  created() {
    if (process.env.VUE_APP_ISSYS4CONJUNTO == 'true') {
      if (this.instalacion === null || this.instalacion ==='' || this.instalacion ===  undefined) {
        this.$root.$emit('mostrarAlerta', 'Falta el nombre de la instalacion en la url', 'error')
      } 
    } else {
      this.instalacion = ''
    }
    this.cambioTitulo()
    if (localStorage.getItem("usuariosLogin") !== null) {
      this.usuariosLogin = JSON.parse(localStorage.getItem("usuariosLogin"))
    }
  },
  computed: {
    isDisabled(){
      if (this.credenciales.login===null || this.credenciales.login==="" || this.credenciales.password===null || this.credenciales.password==="" )
        return true;
      else
        return false;
    }
  },
  methods: {
    cambioTitulo() {
      this.$store.state.tituloIcono = ''
      this.$store.state.titulo = ''
    },
    login() {
      this.$store.dispatch("login", { user: this.credenciales.login, password: this.credenciales.password, instalacion: this.instalacion })
        .then(() => {
          this.conectarUsuario()
          if (!this.$store.getters.isAdminSYS4) {
            this.gestionMultiLogin()
            this.$router.push('/tienda')
          } else {
            this.$router.push('/personal')
          }
        })
        .catch(error => {
          console.log(error)
          this.loginError = true;
          this.$root.$emit('mostrarAlerta', error, 'error')
        })
      this.$store.dispatch("saveLang", "es")
    },
    conectarUsuario() {
      var data = { sesion: this.$store.getters.getSesion, idOauth: this.$store.state.userInfo.uid, aplicacion: 1, instalacion: this.instalacion };
      this.$socket.emit('usuario', data)
    },
    gestionMultiLogin() {
      if (this.usuariosLogin) {
        this.usuariosLogin.forEach((element, index, object) => {
          if (element.nombre === this.credenciales.login) {
            object.splice(index, 1)
          }
        })
        this.usuariosLogin.unshift({
          "nombre" :  this.credenciales.login,
        })
        
        if (this.usuariosLogin.length.length > 3) this.usuariosLogin.length.length = 3
        localStorage.setItem("usuariosLogin", JSON.stringify(this.usuariosLogin))
      }
    },
    completarLogin(nombre) {
      this.credenciales.login = nombre
      this.credenciales.password = ''
      this.$refs.password.focus();
    }
  }
};
</script>